<template>
  <!-- 上传文件公共组件 -->
  <div>
    <el-upload
      :headers="skk_headers"
      class="upload-demo"
      :action="excel ? `${$api_url}project/upload` : `${$api_url}common/upload`"
      :file-list="fileList"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="onUploadSuccess"
      :before-upload="beforeUpload"
      :accept="excel ? acceptExcel : accept"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="previewUrl" alt="预览图片" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      token: "",
      dialogVisible: false, //预览弹窗
      fileList: [],
      limitType: [],
      skk_headers: {},
      dialogImageUrl: "",
      previewUrl: "",
      limitSize: 500 * 1024,
      //excel文件格式
      acceptExcel: ".xlsx,.xls",
      //图片格式
      accept: ".png,.jpg,.jpeg"
    };
  },
  props: {
    files: {
      type: String,
      default: ""
    },
    filesExcel: {
      type: Array,
      default: () => {
      }
    },
    excel: {
      type: Boolean,
      default: false
    },
    hasUploadExcel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["userinfo"])
  },
  watch: {
    files: {
      handler(val) {
        if (val) {
          // console.log(val, "val------------");
          var temp_domain = `${this.$api_imageUrl}`;

          //测试域名
          // const tepVal = val.replace(/https:\/\/zjzxadmin.jc881.com/g, "");
          //正式域名
          const tepVal = val.replace(/http:\/\/zjqyadmin.ynbzde.com/g, "");

          this.previewUrl = temp_domain + tepVal;
          // const t = val.replace(` ${this.$api_imageUrl}`, "");
          // this.$emit("update:files", t);
          // console.log(this.previewUrl, "this.previewUrl----------------");
          //第二次上传的照片覆盖第一次的照片
          this.fileList = [
            { preview: this.previewUrl, url: val, name: "点击预览" }
          ];
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.token = this.userinfo.token;
    this.skk_headers = {
      token: this.token
    };
  },
  methods: {
    // 上传文件前校验
    // 若返回false或者返回promise且被reject,则停止上传
    beforeUpload(file) {
      const unit = file.name.substring(file.name.lastIndexOf(".") + 1);
      // const AllowFileSize = file.size <= this.limitSize;
      // if (!AllowFileSize) {
      //   this.$message.error("文件大小不能超过500KB！");
      //   return false;
      // }
      if (this.excel) {
        //只能是xlsx xls 格式
      } else {
        //只能是图片格式
        const inAllowFileType = this.limitType.includes(unit);
        //['png', 'jpg', 'jpeg']
        console.log(inAllowFileType, "inAllowFileType"); //true
      }
    },
    onUploadSuccess(response, file) {
      if (response.code == 1 && file && file.name) {
        this.$emit("update:hasUploadExcel", true);
      }
      const { data } = response;

      //excel上传成功拿到后端返回的数据，传值
      //如果是普通图片就赋值给url，excel返回的数据里面没有url
      if (this.excel) {
        this.$emit("update:filesExcel", data);
      } else {
        //图片要预览
        this.previewUrl = data.preview;
        this.fileList = [
          { preview: this.previewUrl, url: data.url, name: "点击预览" }
        ];
        this.$emit("update:files", data.url);
      }
    },
    handleRemove() {
      this.$emit("update:files", "");
    },
    handlePreview() {
      if (this.previewUrl) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-button--primary {
  background: #4379f6;
}
</style>
